import { TAuthUser, TUserType } from '../types/Auth'
import { TTenantAccount } from '../types/Collaborators'
import { TMenu } from '../types/Menu'
import { TTenantSettings } from '../types/Tenant'

const getPermitedAndValid = (
  menus: TMenu[],
  user: TAuthUser | null,
  settings: TTenantSettings | null,
  session: TTenantAccount | null
) => {
  const userType = session
    ? TUserType.Member
    : user?.UserType ?? TUserType.Member
  return menus.filter(
    (m) =>
      m.permissions.includes(userType) &&
      (!m.isValidBySettings || m.isValidBySettings(settings, userType))
  )
}

const MenuFunctions = {
  getPermitedAndValid,
}

export default MenuFunctions
